<template>
  <section class="settingSubjectPage">
    <popup
      v-show="isShowsettingSubject"
      bread="教材管理,课程管理,设置主题资料"
      @onBack="popup_back"
    >
      <audio ref="ref_audio" @ended="overAudio">
        <source :src="currentVoiceUrl">
      </audio>
      <infoUpDown :bread="'主题信息'">
        <el-form class="inline-form-self" :inline="true" label-position="left" label-width="100px">
          <el-form-item prop="approvalState" label="所属教材">
            {{ currentTextBook.teachingName }}
          </el-form-item>
          <el-form-item prop="approvalState" label="教材英文名">
            {{ currentTextBook.teachingEnName }}
          </el-form-item>
          <el-form-item prop="approvalState" label="教材等级">
            {{ currentTextBook.teachingGrade }}
          </el-form-item>
          <el-form-item prop="approvalState" label="主题名称">
            {{ themeRow.themeName }}
          </el-form-item>
        </el-form>
      </infoUpDown>
      <infoUpDown :bread="'主题资料'">
        <div class="data-cell">
          <div class="top">
            <div class="tit">自然拼读({{ naturalSpellingList.length }})</div>
            <div>
              <el-button
                type="success"
                :disabled="naturalSpellingList.length === 30"
                @click="uploadDataClick('uploadNaturalSpellingPage')"
              >上传自然拼读</el-button>
              <el-button
                type="warning"
                @click="editCenterForSingerCheck ('editNaturalSpellingPage',naturalSpellingList,checkList,)"
              >编辑自然拼读</el-button>
              <el-button
                type="danger"
                @click="deleteEventCenter(checkList,'checkList')"
              >删除自然拼读</el-button>
            </div>
          </div>
          <div class="maxCon">
            <div
              v-for="(item, index) in naturalSpellingList"
              :key="index"
              class="group-list-wraper"
            >
              <div class="group-tit">
                <el-radio
                  v-model="checkList"
                  style="margin-right: 10px"
                  :label="item.id"
                >{{ item.wordName }}</el-radio>
                <!-- {{ item.wordName }} -->
              </div>
              <ul class="cont">
                <li v-for="(item2, index2) in item.basicMeansResList" :key="index2" class="file-card">
                  <el-image :src="item2.cardChartPath" fit="fit" lazy />
                  <h3 class="tit">{{ item2.wordName }}</h3>
                  <el-button class="icon-voice" type="primary" circle @click=" voiceClick( item2, 'pronunciationPath', 'naturalSpelling' + index + index2 ) ">
                    <i :class=" 'naturalSpelling' + index + index2 === currentIndex ? 'suonaAnimation' : '' " class="suonaIcon" />
                  </el-button>
                </li>
              </ul>
            </div>
            <!-- </el-checkbox-group> -->
          </div>
        </div>
        <div class="data-cell">
          <div class="top">
            <div class="tit">字母({{ letterMeansList.length }})</div>
            <div>
              <el-button
                type="success"
                :disabled="letterMeansList.length === 26"
                @click="uploadDataClick('uploadLetterPage', letterMeansList.length)"
              >上传字母</el-button>
              <el-button
                type="warning"
                @click="
                  editSentenceClick('editLetterPage', letterMeansList, editLetterList)
                "
              >编辑字母</el-button>
              <el-button
                type="danger"
                @click="deleteEventCenter(editLetterList,'editLetterList')"
              >删除字母</el-button>
            </div>
          </div>
          <div class="maxCon">
            <ul v-if="letterMeansList.length > 0" class="cont">
              <li
                v-for="(item, index) in letterMeansList"
                :key="index"
                class="file-card"
              >
                <el-image :src="item.cardChartPath" fit="fit" lazy />
                <h3 class="tit">
                  <el-radio
                    v-model="editLetterList"
                    :label="item.id"
                    class="box-radio"
                  >{{ item.wordName }}</el-radio>
                </h3>
                <el-button class="icon-voice" type="primary" circle @click="voiceClick(item, 'pronunciationPath', 'word' + index)">
                  <i :class=" 'word' + index === currentIndex ? 'suonaAnimation' : '' " class="suonaIcon" />
                </el-button>
              </li>
            </ul>
            <!-- </el-checkbox-group> -->
          </div>
        </div>
        <div class="data-cell">
          <div class="top">
            <div class="tit">单词({{ wordMeansList.length }})</div>
            <div>
              <el-button
                type="success"
                :disabled="wordMeansList.length === 30"
                @click="uploadDataClick('uploadWordPage', wordMeansList.length)"
              >上传单词</el-button>
              <el-button
                type="warning"
                @click="
                  editSentenceClick('editWordPage', wordMeansList, editWordList)
                "
              >编辑单词</el-button>
              <el-button
                type="danger"
                @click="deleteEventCenter(editWordList,'editWordList')"
              >删除单词</el-button>
            </div>
          </div>
          <div class="maxCon">
            <!-- <el-checkbox-group v-model="editWordList"> -->
            <ul v-if="wordMeansList.length > 0" class="cont">
              <li
                v-for="(item, index) in wordMeansList"
                :key="index"
                class="file-card"
              >
                <el-image :src="item.cardChartPath" fit="fit" lazy />
                <h3 class="tit">
                  <el-radio
                    v-model="editWordList"
                    :label="item.id"
                    class="box-radio"
                  >{{ item.wordName }}</el-radio>
                </h3>
                <el-button
                  class="icon-voice"
                  type="primary"
                  circle
                  @click="voiceClick(item, 'pronunciationPath', 'word' + index)"
                >
                  <i
                    :class="'word' + index === currentIndex ? 'suonaAnimation' : ''"
                    class="suonaIcon"
                  />
                </el-button>
              </li>
            </ul>
            <!-- </el-checkbox-group> -->
          </div>
        </div>
        <div class="data-cell">
          <div class="top">
            <div class="tit">高频词({{ highFrequencyList.length }})</div>
            <div>
              <el-button
                type="success"
                :disabled="highFrequencyList.length === 30"
                @click="uploadDataClick('highFrequencyWordPage')"
              >上传高频词</el-button>
              <el-button
                type="warning"
                @click="editCenterForSingerCheck ('editHighFrequencyWordPage', highFrequencyList,checkHighWordList)"
              >编辑高频词</el-button>
              <el-button
                type="danger"
                @click="deleteEventCenter(checkHighWordList,'checkHighWordList')"
              >删除高频词</el-button>
            </div>
          </div>
          <div class="maxCon">
            <div
              v-for="(item, index) in highFrequencyList"
              :key="index"
              class="group-list-wraper"
            >
              <div class="group-tit">
                <el-radio
                  v-model="checkHighWordList"
                  style="margin-right: 10px"
                  :label="item.id"
                >{{ item.wordName }}</el-radio>
              </div>
              <ul class="cont">
                <li
                  v-for="(item2, index2) in item.basicMeansResList"
                  :key="index2"
                  class="file-card"
                >
                  <el-image :src="item2.cardChartPath" fit="fit" lazy />
                  <h3 class="tit">{{ item2.wordName }}</h3>
                  <el-button
                    class="icon-voice"
                    type="primary"
                    circle
                    @click=" voiceClick(item2,'pronunciationPath','highFrequency' + index + index2)"
                  >
                    <i :class="'highFrequency' + index + index2 === currentIndex ? 'suonaAnimation': ''" class="suonaIcon" />
                  </el-button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data-cell">
          <div class="top">
            <div class="tit">句型({{ sentencePatternList.length }})</div>
            <div>
              <el-button
                type="success"
                :disabled="sentencePatternList.length === 30"
                @click="uploadDataClick('uploadSentencePage',sentencePatternList.length)"
              >上传句型</el-button>
              <el-button
                type="warning"
                @click="editSentenceClick('editSentencePage', sentencePatternList,checkSentencePatternList )"
              >编辑句型</el-button>
              <el-button
                type="danger"
                @click="deleteEventCenter(checkSentencePatternList,'checkSentencePatternList')"
              >删除句型</el-button>
            </div>
          </div>
          <div class="maxCon">
            <!-- <el-checkbox-group v-model="checkSentencePatternList"> -->
            <ul v-if="sentencePatternList.length > 0" class="cont">
              <li
                v-for="(item, index) in sentencePatternList"
                :key="index"
                class="file-card"
              >
                <el-image :src="item.cardChartPath" fit="fit" lazy />
                <!-- <h3 class="tit">{{ item.wordName }}</h3> -->
                <el-radio
                  v-model="checkSentencePatternList"
                  :label="item.id"
                  class="box-radio"
                  :show-overflow-tooltip="true"
                >
                  {{ item.wordName }}
                </el-radio>
                <el-button
                  class="icon-voice"
                  type="primary"
                  circle
                  @click="
                    voiceClick(item, 'pronunciationPath', 'sentence' + index)
                  "
                >
                  <i :class=" 'sentence' + index === currentIndex ? 'suonaAnimation' : '' " class="suonaIcon" />
                </el-button>
              </li>
            </ul>
            <!-- </el-checkbox-group> -->
          </div>
        </div>
        <div class="data-cell">
          <div class="top">
            <div class="tit">句型组({{ sentencePatternGroupList.length }})</div>
            <div>
              <el-button
                type="success"
                :disabled="sentencePatternGroupList.length === 30"
                @click="uploadDataClick('uploadSentenceGroupPage')"
              >上传句型组</el-button>
              <el-button
                type="warning"
                @click=" editCenterForSingerCheck( 'editSentenceGroupPage', sentencePatternGroupList, sentenceGroupCheckList )"
              >编辑句型组</el-button>
              <el-button
                type="danger"
                @click="deleteEventCenter(sentenceGroupCheckList,'sentenceGroupCheckList')"
              >删除句型组</el-button>
            </div>
          </div>
          <div class="maxCon">
            <div
              v-for="(item, index) in sentencePatternGroupList"
              :key="index"
              class="group-list-wraper"
            >
              <div class="group-tit">
                <el-radio
                  v-model="sentenceGroupCheckList"
                  style="margin-right: 10px"
                  :label="item.id"
                >{{ item.wordName }}</el-radio>
              </div>
              <ul class="cont">
                <li v-for="(item2, index2) in item.basicMeansResList" :key="index2" class="file-card">
                  <el-image :src="item2.cardChartPath" fit="fit" lazy />
                  <h3 class="tit">{{ item2.wordName }}</h3>
                  <el-button
                    class="icon-voice"
                    type="primary"
                    circle
                    @click="
                      voiceClick(item2, 'pronunciationPath')
                      'sentenceGroup' + index + index2
                    "
                  >
                    <i :class=" 'sentenceGroup' + index + index2 === currentIndex ? 'suonaAnimation' : '' " class="suonaIcon" />
                  </el-button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data-cell">
          <div class="top">
            <div class="tit">video({{ videoList.length }})</div>
            <div>
              <el-button
                type="success"
                :disabled="videoList.length === 30"
                @click="uploadDataClick('uploadVideoPage', videoList.length)"
              >上传video</el-button>
              <el-button
                type="warning"
                @click="
                  editSentenceClick('editVideoPage', videoList, videoCheckList)
                "
              >编辑video</el-button>
              <el-button
                type="danger"
                @click="deleteEventCenter(videoCheckList,'videoCheckList')"
              >删除video</el-button>
            </div>
          </div>
          <div class="maxCon">
            <ul v-if="videoList.length > 0" class="cont">
              <li v-for="(item, index) in videoList" :key="index" class="file-card">
                <el-image :src="item.cardChartPath" fit="fit" lazy />
                <h3 class="tit">
                  <el-radio v-model="videoCheckList" :label="item.id" class="box-radio">{{ item.wordName }}</el-radio>
                </h3>
              </li>
            </ul>
          </div>
        </div>
      </infoUpDown>
    </popup>
    <component
      :is="componentId"
      ref="ref_commonUpload"
      :current-number="currentNumber"
      :timestamp="timestamp"
      :theme-row="themeRow"
      @resetFetchData="fetchData"
    />
  </section>
</template>

<script>
import {
  editNaturalSpellingPage,
  uploadNaturalSpellingPage,
  uploadLetterPage,
  uploadWordPage,
  editWordPage,
  highFrequencyWordPage,
  uploadSentencePage,
  editHighFrequencyWordPage,
  uploadSentenceGroupPage,
  editSentencePage,
  editSentenceGroupPage,
  uploadVideoPage,
  editVideoPage,
  editLetterPage
} from './index.js'
import {
  delBasicMeans
} from '../../../../api/teachBookManagement/courseManagement'
import { selectThemeDataDetail, searchDetailBysentenceGroup, searchDetailByNatural, searchDetailByBasic } from '@api/courseManagement/api_setThemeData'
// import { serachDetail } from '../../../../api/teachBookManagement/courseManagement'
// import { mapState } from 'vuex'
export default {
  components: {
    uploadNaturalSpellingPage,
    uploadWordPage,
    highFrequencyWordPage,
    uploadSentencePage,
    uploadSentenceGroupPage,
    editNaturalSpellingPage,
    editWordPage,
    editHighFrequencyWordPage,
    editSentencePage,
    editSentenceGroupPage,
    uploadVideoPage,
    uploadLetterPage,
    editVideoPage,
    editLetterPage
  },
  props: {
    currentTextBook: {
      type: Object,
      default: null
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      currentIndex: -1,
      currentNumber: 0,
      isShowsettingSubject: false,
      currentVoiceUrl: '',
      componentId: 'uploadNaturalSpellingPage',
      timestamp: 0,
      naturalSpellingList: [],
      highFrequencyList: [],
      sentencePatternList: [],
      sentencePatternGroupList: [],
      letterMeansList: [],
      wordMeansList: [],
      checkList: [],
      editNaturalList: [],
      editWordList: [],
      editLetterList: [],
      checkHighWordList: [],
      checkSentencePatternList: [],
      sentenceGroupCheckList: [],
      editWordCheckList: [],
      videoList: [],
      videoCheckList: []
    }
  },
  computed: {
    // ...mapState('settingThemeData', ['editShow'])
  },
  watch: {},
  created () {
    // this.fetchData()
  },
  mounted () { },
  methods: {
    fetchData () {
      selectThemeDataDetail({ teachingThemeId: this.themeRow.id }).then(
        (res) => {
          this.naturalSpellingList = res.naturalSpellingList
          this.letterMeansList = res.letterList
          this.wordMeansList = res.wordMeansList
          this.highFrequencyList = res.highFrequencyList
          this.sentencePatternList = res.sentencePatternList
          this.sentencePatternGroupList = res.sentencePatternGroupList
          this.videoList = res.videoList
          this.checkList = []
          this.editWordList = []
          this.checkHighWordList = []
          this.checkSentencePatternList = []
          this.sentenceGroupCheckList = []
          this.videoCheckList = []
          this.editLetterList = []
        }
      )
    },
    // 返回
    popup_back () {
      this.isShowsettingSubject = false
      // this.$emit('resetFetchData')
    },
    uploadDataClick (componentId, len) {
      this.componentId = componentId
      this.currentNumber = len
      this.$nextTick(() => {
        this.timestamp = Date.now()
      })
    },
    voiceClick (item, key, index) {
      this.currentIndex = index
      this.currentVoiceUrl = item[key]
      this.$nextTick(() => {
        this.$refs.ref_audio.load()
        this.$refs.ref_audio.play()
      })
    },
    overAudio () {
      this.currentIndex = -1
    },

    // 编辑多选框句型的弹出事件
    editSentenceClick (page, list, checkList, len) {
      if (checkList.length < 1) {
        this.$message.error('请至少选择一项')
        return
      }
      const array = []
      list.filter((e) => {
        if (checkList === e.id) {
          array.push(e)
        }
      })
      this.jumpSwitch(page, len, array)
    },
    pageNext(page, len) {
      this.componentId = page
      this.currentNumber = len
      this.$nextTick(() => {
        this.timestamp = Date.now()
      })
    },
    // 统一的单选按钮事件
    editCenterForSingerCheck (page, list, checkList, len) {
      if (checkList.length < 1) {
        this.$message.error('请至少选择一项')
        return
      }
      const array = []
      list.filter((e) => {
        if (e.id === checkList) {
          array.push(e)
        }
      })
      this.jumpSwitch(page, len, array)
    },
    // 代替switch语句，提高代码可读性
    jumpSwitch(page, len, array) {
      // console.log(array)
      const actions = {
        'editSentenceGroupPage': ['settingThemeData/SET_CHANGESENTENCEGROUP', array, searchDetailBysentenceGroup],
        'editNaturalSpellingPage': ['settingThemeData/SET_CHANGEEDITLIST', array, searchDetailByNatural],
        'editHighFrequencyWordPage': ['settingThemeData/SET_CHANGEHIGHWORDLIST', array, searchDetailByNatural],
        'editSentencePage': ['settingThemeData/SET_CHANGESENTENCELIST', array, searchDetailByBasic],
        'editWordPage': ['settingThemeData/SET_CHANGEWORDLIST', array, searchDetailByBasic],
        'editVideoPage': ['settingThemeData/SET_CHANGEVIDEOLIST', array, searchDetailByBasic],
        'editLetterPage': ['settingThemeData/SET_CHANGELETTERLIST', array, searchDetailByBasic]
      }
      const onPageJump = async(status) => {
        const action = actions[status]
        try {
          // await Promise.all(array.map(async(item) => {
          //   if (action[2]) {
          //     res = await action[2]({ id: item.id })
          //     return
          //   } else {
          //     return
          //   }
          // }))
          let res = []
          if (action[2]) {
            res = await action[2]({ id: array[0].id })
          } else {
            return
          }
          console.log(res)
          if (Array.isArray(res)) {
            console.log('传递了数组')
            this.$store.commit(action[0], res)
          } else {
            console.log('传递了未修改的')
            this.$store.commit(action[0], [res])
          }
          this.pageNext(page, len)
        } catch (e) {
          this.$message.closeAll()
          this.$message.error(e)
        }
      }
      onPageJump(page)
    },
    // 删除请求
    async deleteSyncList(deleteArray) {
      try {
        await Promise.all(deleteArray.map(async (item) => {
          // 等待异步操作完成，返回执行结果
          return await delBasicMeans({ id: item })
        }))
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        this.$message.closeAll()
        this.$message.error(error)
      }
    },

    // 统一的删除按钮
    deleteEventCenter (list, listName) {
      if (list.length < 1) {
        this.$message.error('请至少选择一项')
      } else {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.swtichDelete(list, listName)
          })
          // .catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          //   })
          // })
      }
    },
    swtichDelete(list, listName) {
      const actions = {
        'checkSentencePatternList': [list],
        'checkHighWordList': [list],
        'editWordList': [list],
        'checkList': [list],
        'sentenceGroupCheckList': [list],
        'editLetterList': [list],
        'videoCheckList': [list]
      }
      const onDataDelete = (status) => {
        const action = actions[status]
        this.deleteSyncList(action)
      }
      onDataDelete(listName)
    }

  }
}
</script>
<style lang='scss'>
.box-radio{
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.el-radio__label{
    -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.settingSubjectPage {
  .inline-form-self {
    .el-form-item {
      margin-right: 8%;
      margin-bottom: 0;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .data-cell {
    margin-bottom: 25px;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .tit {
        display: flex;
        align-items: center;
        color: #53402b;
        &::before {
          content: '';
          width: 6px;
          height: 22px;
          display: inline-block;
          background: #fcda6f;
          margin-right: 8px;
          border-radius: 9px;
        }
      }
    }
    .cont {
      overflow-x: auto;
      overflow-y: hidden;
      padding-bottom: 16px;
      display: flex;
      .file-card {
        background: #f7f6f4;
        border-radius: 12px;
        padding: 16px;
        text-align: center;
        position: relative;

        margin-right: 20px;
        width: 168px;
        flex-shrink: 0;

        .el-image {
          width: 136px;
          height: 126px;
          border-radius: 8px;
          margin-bottom: 15px;
          background-color: white;
        }
        .tit {
          width: 100%;
          font-size: 14px;
          line-height: 16px;
          height: 32px;
          color: #45433d;
          overflow: hidden;
          text-overflow: ellipsis;
          // display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .icon-voice {
          position: absolute;
          right: 22px;
          top: 22px;
          width: 30px;
          height: 30px;
          padding: 7px;
          box-shadow: 0px 3px 6px rgba(248, 212, 91, 0.5);
          cursor: pointer;
          .suonaIcon {
            width: 13px;
            height: 11px;
            display: inline-block;
            background-image: url('../../../../assets/images/suona3.png');
            &.suonaAnimation {
              animation: myfirst 1s infinite;
              // /* Safari and Chrome */
              -webkit-animation: myfirst 1s infinite;
            }
          }
          @keyframes myfirst {
            0% {
              background-image: url('../../../../assets/images/suona1.png');
            }
            50% {
              background-image: url('../../../../assets/images/suona2.png');
            }
            100% {
              background-image: url('../../../../assets/images/suona3.png');
            }
          }

          @-webkit-keyframes myfirst /* Safari and Chrome */ {
            0% {
              background-image: url('../../../../assets/images/suona1.png');
            }
            50% {
              background-image: url('../../../../assets/images/suona2.png');
            }
            100% {
              background-image: url('../../../../assets/images/suona3.png');
            }
          }
        }
      }
    }
    .maxCon {
      max-height: 510px;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .group-list-wraper {
      .group-tit {
        margin-bottom: 14px;
        color: #45433d;
        font-size: 14px;
      }
    }
  }
}
</style>
